import React, { useEffect, useState } from "react";
import { Box, Grid, CircularProgress, Typography } from "@mui/material";
import OfflineDevice from "./OfflineDevice";
import { telemetryService } from "../../../services/TelemetryService";

// TODO: Upgrade to mui 5 styling system: 
const classes = {
    container: {
        flexGrow: 1,
        marginTop: 8,
        align: "start",
        backgroundColor: "grey",
    },
    loadingContainer: {
        margin: 20,
        width: "100%",
    },
};

export default function OfflineDeviceChart() {
    const [v3Data, setV3Data] = useState(null);
    const [polarisData, setPolarisData] = useState(null);
    const [initialLoad, setInitialLoad] = useState(false);

    function parseData(data) {
        const total = parseInt(data["total_devices"]);
        const offline = parseInt(data["offline_devices"]);
        const online = total - offline;
        const updated = data["updated"] ? new Date(data["updated"]) : "";
        const percent = ((online / total) * 100).toFixed(0);

        return {
            total,
            offline,
            online,
            updated,
            percent,
        };
    }

    function formatData() {
        let data = [];

        if (initialLoad) {
            const polarisDict = parseData(polarisData);
            const v3Dict = parseData(v3Data);

            data = [
                Object.assign(
                    {
                        name: "POLARIS",
                        color: "#A5D8DD",
                    },
                    parseData(polarisData)
                ),
                Object.assign(
                    {
                        name: "V3",
                        color: "#0091D5",
                    },
                    parseData(v3Data)
                ),
                {
                    name: "TOTAL",
                    color: "#EA6A47",
                    offline: polarisDict.offline + v3Dict.offline,
                    total: polarisDict.total + v3Dict.total,
                    online: polarisDict.online + v3Dict.online,
                    percent: (
                        ((polarisDict.online + v3Dict.online) / (polarisDict.total + v3Dict.total)) *
                        100
                    ).toFixed(0),
                    updated: new Date(Math.max.apply(null, [polarisDict.updated, v3Dict.updated])),
                },
            ];
        }

        return data;
    }

    async function getData() {
        const [v3Response, polarisResponse] = await Promise.all([
            telemetryService.getOfflineDevices("v3"),
            telemetryService.getOfflineDevices("polaris"),
        ]);

        if (v3Response || polarisResponse) {
            setV3Data(v3Response.data[0]);
            setPolarisData(polarisResponse.data[0]);

            setInitialLoad(true);
        }
    }

    function displayData() {
        if (!initialLoad) {
            return (
                <Grid sx={classes.loadingContainer} item>
                    <Typography sx={classes.text}>LOADING...</Typography>
                    <CircularProgress size={35} sx={classes.loading} />
                </Grid>
            );
        } else {
            return formatData().map((card) => (
                <Grid item lg={4} sm={6} xl={4} xs={12} key={card.name}>
                    <OfflineDevice
                        sx={{ height: "100%" }}
                        device={card.name}
                        total={card.total}
                        online={card.online}
                        color={card.color}
                        percent={card.percent}
                        updated={card.updated}
                    />
                </Grid>
            ));
        }
    }

    useEffect(() => {
        if (!initialLoad) {
            getData();
        }

        const interval = setInterval(() => {
            getData();
        }, 60000);
        return () => clearInterval(interval);
    }, [initialLoad]);

    return (
        <Box component={Grid} container spacing={5}>
            {displayData()}
        </Box>
    );
}
